
import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Demo from './screens/Demo';

import { Toaster } from './toaster';
import { NotFound } from './screens/Errors/NotFound';
import { Unauthorized } from './screens/Errors/Unauthorized';
import { MissingLicense } from './screens/Errors/MissingLicense';

function App() {
  return (
    <div className="app h-screen">
      <Router>

        <Routes>
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/missing-license" element={<MissingLicense />} />
          <Route path="/not-found" element={<NotFound />} />

          <Route path="/" element={<Demo />} />
        </Routes>

      </Router>
      <Toaster />
    </div>
  );
}

export default App;
